import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { isEmpty } from "lodash";
import React, { useState } from "react";

import { connect } from "react-redux";

const TransferCriteriaDialog = (props) => {
  const { user, transferEligibility, academicYears } = props;

  const previousAcademicYears = () => {
    const index = academicYears.findIndex(
      ({ id }) => id === user?.selectedAcademicYear?.id,
    );
    return academicYears[index + 1] || user?.selectedAcademicYear;
  };

  // previousAcademicYears();

  return (
    <div>
      <ol>
        <li>
          You must complete the required profile information. Teachers must also
          have assigned subjects.
          {!isEmpty(transferEligibility) &&
          transferEligibility.hasVerifiedProfile ? (
            <i className="text-success fas fa-check-circle"></i>
          ) : (
            <i className="text-danger fas fa-times-circle"></i>
          )}
        </li>
        <li>
          You must have scored at least 70% in performance evaluation in the{" "}
          <strong>{previousAcademicYears().name}</strong> school year{" "}
          <i className="text-primary fas fa-ellipsis-h"></i>
        </li>
        <li>
          You must have successfully completed three (3) years of service at the
          same school, probation period included.
          {!isEmpty(transferEligibility) &&
          transferEligibility.hasThreeYearsInService ? (
            <i className="text-success fas fa-check-circle"></i>
          ) : (
            <i className="text-danger fas fa-times-circle"></i>
          )}
        </li>
        <li>
          Upgraded teachers will only be eligible for transfer if they have
          successfully served at least three (3) years at the same school and
          same position.
          {!isEmpty(transferEligibility) &&
          transferEligibility.hasThreeYearsInService ? (
            <i className="text-success fas fa-check-circle"></i>
          ) : (
            <i className="text-danger fas fa-times-circle"></i>
          )}
        </li>
        <li>
          Teachers who were transferred or interchanged (permutation) will only
          be eligible for transfer if they have completed at least three (3)
          years of service after the previous transfer/interchange
          {!isEmpty(transferEligibility) &&
          transferEligibility.hasThreeYearsAfterPreviousTransfer ? (
            <i className="text-success fas fa-check-circle"></i>
          ) : (
            <i className="text-danger fas fa-times-circle"></i>
          )}
        </li>
        <li>
          Teachers whose request for internal transfer or interchange
          (permutation) that has not been successful, are also eligible to apply
          for internal or external transfer
          {!isEmpty(transferEligibility) &&
          transferEligibility.hasThreeYearsAfterPreviousTransfer ? (
            <i className="text-success fas fa-check-circle"></i>
          ) : (
            <i className="text-danger fas fa-times-circle"></i>
          )}
        </li>

        {user?.selectedScope?.id !== "RTB" && (
          <li>
            Teachers interchanging must have the same profile{" "}
            <i className="text-primary fas fa-ellipsis-h"></i>
          </li>
        )}

        <li>
          Only certified teachers or administrative and support staff are
          eligible to apply.{" "}
          {!isEmpty(transferEligibility) && transferEligibility.isCertified ? (
            <i className="text-success fas fa-check-circle"></i>
          ) : (
            <i className="text-danger fas fa-times-circle"></i>
          )}
        </li>

        {!!transferEligibility.needRecommendation && (
          <li>
            <strong>
              Recommendation letter from the District is required for School
              Accountants, Bursars, and administrative staff (HTs, DOS, and
              DOD).
            </strong>
            <i className="text-primary fas fa-ellipsis-h"></i>
          </li>
        )}
        {/* <br />
        <br />
        <em>
          <strong style={{ textDecoration: "underline" }}>Note:</strong>{" "}
          Transfer and Interchange (permutation) of Head teachers, Deputy Head
          teachers is only open for those who got 70% or above in their
          performance evaluation.
          {!isEmpty(transferEligibility) &&
          transferEligibility.isRoleAllowed ? (
            <i className="text-success fas fa-check-circle"></i>
          ) : (
            <i className="text-danger fas fa-times-circle"></i>
          )}
        </em> */}
      </ol>
    </div>
  );
};

const mapStateToProps = ({ user, transferEligibility, academicYears }) => {
  return { user, transferEligibility, academicYears };
};
export default connect(mapStateToProps, {})(TransferCriteriaDialog);
